import './basic_textarea.less';

import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import withFocusOnMount from './with_focus_on_mount.jsx';

const TextArea = withFocusOnMount('textarea');

export const withBasicTextarea = (ComponentToWrap)=> {
  const WrappedTextArea = ({ className, onEnterKeyUp, ...props})=>(
    <ComponentToWrap
      onKeyUp={(e)=> {
        if (e.keyCode === 13 && onEnterKeyUp) {
          onEnterKeyUp(e);
        }
      }}
      {...props} 
      className={classNames('basic-textarea', className)} 
    />
  );

  WrappedTextArea.propTypes = {
    onEnterKeyUp: PropTypes.func
  };
  WrappedTextArea.defaultProps = {
    onEnterKeyUp: noop
  };
  return WrappedTextArea;
};


const BasicTextArea = withBasicTextarea(
  (props)=> 
    <TextArea {...props} />
);

export default BasicTextArea;
